import { connect } from 'react-redux'
import HomePage from '../components/HomePage'
import * as homePageActions from '../actions/homePage'
import * as formDialogActions from '../actions/formDialogActions'
import * as login from '../actions/login'

const mapStateToProps = (state, ownProps) => {
	
	return {
		...state.homePage,
		username: state.login.username,
		roles: state.login.roles,
		environment: state.login.environment,
		goBack: false,
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({
	onSave: () => dispatch(homePageActions.save()),
	onCancel: (profile) => dispatch(homePageActions.cancel(profile)),
	logout: () => dispatch(login.logout()),
	handleAccountSetupChangeValue: (event) => dispatch(homePageActions.accountChangeValue(event)),
	handleAccountSetupChangeValueOld: (event) => dispatch(homePageActions.accountChangeValueOld(event)),
	lbbSearch: (lbbAccountNumber) => dispatch(homePageActions.lbbSearch(lbbAccountNumber)),
	handleContactChangeValue: (event) => dispatch(homePageActions.handleContactChangeValue(event)),
	handleContactChangeValueSelect: (event) => dispatch(homePageActions.handleContactChangeValueSelect(event)),
	addressChange: (address) => dispatch(homePageActions.addressChange(address)),
	accountEdit: (accountNumber, accountName) => dispatch(homePageActions.accountEdit(accountNumber, accountName)),
	addContact: () => dispatch(homePageActions.addContact()),
	removeContact: (index) => dispatch(homePageActions.removeContact(index)),
	handlePoPreferenceChangeValue: (event) => dispatch(homePageActions.handlePoPreferenceChangeValue(event)),
	addPoPreference: () => dispatch(homePageActions.addPoPreference()),
	removePoPreference: (index) => dispatch(homePageActions.removePoPreference(index)),
	handleAccountNumbersChange: (event) => dispatch(homePageActions.handleAccountNumbersChange(event)),
	handleAccountNumbersChangeSelect: (event) => dispatch(homePageActions.handleAccountNumbersChangeSelect(event)),
	addOtherAccountNumbers: () => dispatch(homePageActions.addOtherAccountNumbers()),
	removeOtherAccountNumbers: (index) => dispatch(homePageActions.removeOtherAccountNumbers(index)),
	handleDomainChangeValue: (event) => dispatch(homePageActions.handleDomainChangeValue(event)),
	handleNotificationChange: (event) => dispatch(homePageActions.handleNotificationChange(event)),
	addNotification: () => dispatch(homePageActions.addNotification()),
	removeNotification: (index) => dispatch(homePageActions.removeNotification(index)),
	wheelChange: (event) => dispatch(homePageActions.wheelChange(event)),
	wheelChangeSelect: (event) => dispatch(homePageActions.wheelChangeSelect(event)),
	addWheel: () => dispatch(homePageActions.addWheel()),
	removeWheel: (index) => dispatch(homePageActions.removeWheel(index)),
	tireChange: (event) => dispatch(homePageActions.tireChange(event)),
	tireChangeSelect: (event) => dispatch(homePageActions.tireChangeSelect(event)),
	addTire: () => dispatch(homePageActions.addTire()),
	duplicateTire: (tire) => dispatch(homePageActions.duplicateTire(tire)),
	removeTire: (index) => dispatch(homePageActions.removeTire(index)),
	openDialog: () => dispatch(formDialogActions.open()),
	closeDialog: () => dispatch(formDialogActions.close()), 
	snackClose: () => dispatch(homePageActions.snackClose()),
	poRequiredChange: (event) => dispatch(homePageActions.poRequiredChange(event)),
	ccRequiredChange: (event) => dispatch(homePageActions.ccRequiredChange(event)),
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(HomePage)



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js